import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

import Button from 'components/Buttons/Button';

export const Container = styled.div`
  @media ${({ theme }) => theme.device.desktop} {
    position: absolute;
    width: 500px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    background: ${ColorPalette.HEX.White};
    border-radius: 10px;
    box-shadow: 0 2px 8px 0 rgba(${ColorPalette.RGB.Black}, 0.2);
    padding: 16px;
  }
`;

export const Body = styled.div`
  padding: 20px;
`;

export const TextHeader = styled.span`
  text-align: center;
  align-self: center;
  & > h3 {
    font-weight: bold;
  }
`;

export const GroupButton = styled.div`
  margin-top: 32px;
`;

export const AcceptButton = styled(Button)`
  font-size: 16px;
`;
